/**
 * 🎓 v7.69 (Javi's brother: "no matter what he did, the tutorial kept popping
 * up... something was wrong with his local storage"): the two flags that end
 * the first steps - the onboarding answer and "practice done" - used to live
 * in localStorage alone, behind a silent try/catch. On a browser whose
 * localStorage refuses writes (private mode, blocked site data, a full
 * quota), every answer was forgotten by the next visit, and the welcome card
 * came back on every Start Run. A flag now lands in localStorage AND
 * sessionStorage AND memory, and reads fall through the same way, so the
 * answer at least holds for the whole browser session when the device
 * cannot keep it for good.
 */
const memory = new Map<string, string>()

function stores(): Storage[] {
  const out: Storage[] = []
  try { if (typeof localStorage !== 'undefined' && localStorage) out.push(localStorage) } catch { /* blocked */ }
  try { if (typeof sessionStorage !== 'undefined' && sessionStorage) out.push(sessionStorage) } catch { /* blocked */ }
  return out
}

export function readFlag(key: string): string | null {
  for (const store of stores()) {
    try {
      const value = store.getItem(key)
      if (value !== null) return value
    } catch { /* next store */ }
  }
  return memory.get(key) ?? null
}

export function writeFlag(key: string, value: string): void {
  memory.set(key, value)
  for (const store of stores()) {
    try { store.setItem(key, value) } catch { /* the next store may still take it */ }
  }
}
